import { Component } from '@angular/core';
import { AuthService } from '../../../../features/auth/services/auth.service';
import { SwalService } from '../../../../common/services/swal.service';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  private baseMenuItems: any[] = [
    {
      route: '/employees',
      icon: 'groups',
      name: 'Usuarios',
    },
    {
      route: '/insurance-types',
      icon: 'shield_with_heart',
      name: 'Productos',
    },
  ];

  private banksMenuItem: any = {
    route: '/banks',
    icon: 'account_balance',
    name: 'Bancos',
  };

  private directorsMenuItem: any = {
    route: '/directors',
    icon: 'admin_panel_settings',
    name: 'Directores',
  };

  private superUserMenuItems: any[] = [
    {
      route: '/coverages',
      icon: 'health_and_safety',
      name: 'Coberturas',
    },
    {
      route: '/occupations',
      icon: 'work',
      name: 'Ocupaciones',
    },
    {
      route: '/parameters',
      icon: 'tune',
      name: 'Parámetros',
    },
  ];

  constructor(private auth: AuthService, private swal: SwalService) { }

  get menuItems(): any[] {
    if (this.auth.isSuperUser) {
      return [
        ...this.baseMenuItems,
        ...this.superUserMenuItems,
        this.banksMenuItem,
        this.directorsMenuItem,
      ];
    }
    if (this.auth.isGlobal) {
      // A global admin has exactly one bank; skip the one-row list
      const bankId = this.auth.bankProfile?.bankId;
      const bankItem = bankId
        ? { route: `/banks/${bankId}/edit`, icon: 'account_balance', name: 'Banco' }
        : this.banksMenuItem;
      return [...this.baseMenuItems, bankItem, this.directorsMenuItem];
    }
    return this.baseMenuItems;
  }

  get isRetailer() {
    return this.auth.isRetailer;
  }

  async logOut() {
    const { isConfirmed } = await this.swal.confirm(
      '¿Estás seguro de que deseas cerrar sesión?',
      'Cerrar Sesión',
      { confirmButtonText: 'Sí, salir' }
    );

    if (isConfirmed) {
      this.auth.logOut();
    }
  }
}
